import React, { useEffect, useState } from 'react'
import { BigImage, DescWrapper, DetailWrapper, ImageSelection, ImageWrapper, Size, SizeContainer, SizeItem, TopDetail, Quantity, BoxCount, Button, SosmedWrap, BottomDetail, Tabs } from './DetailStyle'
import Image1 from '../../assets/images/detail/1.jpeg'
import Image2 from '../../assets/images/detail/2.jpeg'
import Image3 from '../../assets/images/detail/3.jpeg'
import Image4 from '../../assets/images/detail/4.jpeg'
import { FaEye, FaPlus, FaMinus, FaFacebookF, FaTwitter, FaWhatsapp, FaEnvelope, FaPinterestP,  FaYoutube } from "react-icons/fa";
import Modal from './Modal'
import { ChartTab, DescriptionTab, GuideTab, ShippingTab } from './TabContent'

const images = [
  { img: Image1 },
  { img: Image2 },
  { img: Image3 },
  { img: Image4 },
]
const sizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL']
const tabs = ['Description', 'Size Chart', 'Size Guide', 'Shipping Details']

export default function Detail() {
  const [selectedImage, setSelectedImage] = useState(images[0].img)
  const [modal, setModal] = useState(false)
  const modalToggle = () => setModal(prev => !prev)
  const [count, setCount] = useState(1)
  const [activeTab, setActiveTab] = useState(tabs[0])

  const incCount = c => {
    if (c === 10) {
      return
    } else {
      setCount(prev => prev + 1)
    }
  }
  const descCount = c => {
    if (c === 1) {
      return
    } else {
      setCount(prev => prev - 1)
    }
  }
  const changeActiveTab = tab => setActiveTab(tab)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <DetailWrapper>
      <TopDetail>
        <ImageWrapper>
          <BigImage bgImg={selectedImage} />
          <ImageSelection>
            {
              images.map((item, idx) => (
                <div key={idx} onClick={() => setSelectedImage(item.img)} className={selectedImage === item.img ? 'active' : ''}>
                  <img src={item.img} alt="gambar" />
                </div>
              ))
            }
          </ImageSelection>
        </ImageWrapper>
        <DescWrapper>
            <h3>ESMIRA KURUNG (BLACK)</h3>
            <h4>RM 229.00</h4>
            <Size>
              <p>Select Size:</p>
              <SizeContainer>
                {
                  sizes.map((size, idx) => (
                    <SizeItem key={idx}>{size}</SizeItem>
                  ))
                }
              </SizeContainer>
              <p style={{ display:'flex', alignItems:'center' }} onClick={modalToggle}>Size Chart <FaEye /></p>
              {
                modal && <Modal show={modal} modalToggle={modalToggle}/>
              }
            </Size>
            <Quantity>
              <h4>Quantity:</h4>
              <BoxCount>
                <FaMinus onClick={() => descCount(count)} />
                <p>{count}</p>
                <FaPlus onClick={() => incCount(count)} />
              </BoxCount>
            </Quantity>
            <Button onClick={() => alert('Successfully Added to Your Cart')}>add to cart</Button>
            <SosmedWrap>
              <FaFacebookF />
              <FaTwitter />
              <FaWhatsapp />
              <FaEnvelope />
              <FaPinterestP />
              <FaYoutube />
            </SosmedWrap>
        </DescWrapper>
      </TopDetail>
      <BottomDetail>
          <Tabs>
            {
              tabs.map((tab, idx) => (
                <p key={idx} className={activeTab === tab ? 'active' : ''} onClick={() => changeActiveTab(tab)} >{tab}</p>
              ))
            }
          </Tabs>
          
          { activeTab === tabs[0] && <DescriptionTab /> }
          { activeTab === tabs[1] && <ChartTab /> }
          { activeTab === tabs[2] && <GuideTab /> }
          { activeTab === tabs[3] && <ShippingTab /> }
      </BottomDetail>
    </DetailWrapper>
  )
}
